import React from 'react';

import Link from '@buyside/components/presentation/Link/link';

import { userAccreditedInvestorQuestionnaireUrl } from '@buyside/util/urlHelper';

import styles from './toasterStyles.scss';

const AccreditedInvestorToaster: React.FC = () => {
  return (
    <>
      <span>
        Are you an accredited investor looking to invest in hedge funds?{' '}
        <strong>Complete a brief survey</strong> and start engaging with fund managers directly.
      </span>
      <div className={styles.actions}>
        <Link to={userAccreditedInvestorQuestionnaireUrl()}>Complete survey</Link>
      </div>
    </>
  );
};

export default AccreditedInvestorToaster;
